<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xHkhRs/tc-custom/9780813139470.jpg?1736859115282" alt="This image is the cover for the book Spookiest Stories Ever"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spookiest Stories Ever
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A collection of haunting tales set among the landscapes and landmarks of the Bluegrass State.</b></p><p>Tree branches scratching at your window on a stormy April night . . . The hot, sticky oppression of a stifling summer’s day . . . November leaves rustling as a chill sneaks into your bones . . . The darkened days of winter . . . No matter what the season, it’s always a good time for a ghost story.</p><p>From masterful storytelling duo Roberta and Lonnie Brown comes <i>Spookiest Stories Ever: Four Seasons of Kentucky Ghosts, </i>a creepy collection of tales from their home state. Featuring familiar Kentucky landmarks such as the Palace Theater and the Waverly Hills Sanatorium in Louisville and Shaker Village of Pleasant Hill, these accounts from across the commonwealth are sure to put a tingle in the reader’s spine.</p><p>These notable stories, including tales of the “chime child” who can see and talk to ghosts, graveside appearances, and the Spurlington Witch of Taylor County, occur in all four seasons and come from every corner of Kentucky. An essential part of the American storytelling tradition, these ghost stories will delight those who love getting goose bumps all year long.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roberta Simpson Brown, Lonnie E. Brown, Elizabeth Tucker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?774a978f